import { Helmet } from "react-helmet"
import React from "react"

const MetaTags = props => {
  const {title} = props

  return (
    <Helmet title={title}/>
  )
}

export default MetaTags
